export default "__VITE_ASSET__tF4YSBfx__"